<template>
  <div class="app">
    <router-view v-wechat-title="$route.meta.title" :key="key"></router-view>
  </div>
</template>

<script>
export default {
  computed: {
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + +new Date()
        : this.$route + +new Date();
    },
  },
  data() {
    return {
      // isIphonexUp: false
    }
  },

};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

.app {
  width: 100%;
  height: 100%;
}

* {
  box-sizing: border-box;
}

ul,
li {
  margin: 0;
  padding: 0;
}
</style>
